import React from 'react';
import './MegaMenu1.css';

export default function MegaMenu1() {
  return (
    <div className="mega-menu">
      <div className="mega-menu-inner">
        {/* Top cards */}
        <div className="mega-primary">
          <div className="mega-card">
            <div className="mega-icon">
              <BarChartIcon />
            </div>
            <div>
              <h4>Placeholder text 1</h4>
              <p>Lorem ipsum dolor sit amet consecte</p>
            </div>
          </div>

          <div className="mega-card">
            <div className="mega-icon">
              <EmbedIcon />
            </div>
            <div>
              <h4>Placeholder text 2</h4>
              <p>Lorem ipsum dolor sit amet consecte</p>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="mega-divider" />

        {/* Bottom links */}
        <div className="mega-secondary">
          <div className="mega-pill">
            <DatabaseIcon />
            <span>Placeholder 1</span>
          </div>

          <div className="mega-pill">
            <ShieldIcon />
            <span>Placeholder 2</span>
          </div>

          <div className="mega-pill">
            <CloudIcon />
            <span>Placeholder 3</span>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ========== Icons (inline SVG, no libs) ========== */

function BarChartIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <rect className="bar r1" x="2" y="18" width="3" height="10" rx="1" fill="#3B82F6" />
      <rect className="bar r2" x="7" y="14" width="3" height="14" rx="1" fill="#3B82F6" />
      <rect className="bar r3" x="12" y="20" width="3" height="8" rx="1" fill="#3B82F6" />
      <rect className="bar r4" x="17" y="10" width="3" height="18" rx="1" fill="#3B82F6" />
      <rect className="bar r5" x="22" y="16" width="3" height="12" rx="1" fill="#3B82F6" />
    </svg>
  );
}

function EmbedIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" className="embed-spark">
      {/* path used for motion; visible sparkline */}
      <path
        id="sparkPath"
        className="sparkline-path"
        d="M3 18 L8 12 L12 14 L18 8 L24 11"
        fill="none"
        stroke="#60A5FA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* moving dot follows the path precisely using animateMotion; starts on mouseover, stops on mouseout */}
      <circle className="spark-dot" cx="0" cy="0" r="2.6" fill="#60A5FA">
        <animateMotion dur="900ms" repeatCount="indefinite" begin="mouseover" end="mouseout">
          <mpath xlinkHref="#sparkPath" />
        </animateMotion>
      </circle>
    </svg>
  );
}

function DatabaseIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <ellipse cx="12" cy="6" rx="8" ry="3" stroke="#64748B" strokeWidth="1.5" />
      <path d="M4 6V12C4 13.7 7.6 15 12 15C16.4 15 20 13.7 20 12V6" stroke="#64748B" strokeWidth="1.5"/>
    </svg>
  );
}

function ShieldIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 3L4 6V12C4 17 12 21 12 21C12 21 20 17 20 12V6L12 3Z"
        stroke="#64748B"
        strokeWidth="1.5"
      />
    </svg>
  );
}

function CloudIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M7 18H17C19.2 18 21 16.2 21 14C21 11.8 19.2 10 17 10C16.5 7.7 14.5 6 12 6C9.2 6 7 8.2 7 11C5.3 11.2 4 12.7 4 14.5C4 16.4 5.6 18 7.5 18"
        stroke="#64748B"
        strokeWidth="1.5"
      />
    </svg>
  );
}
